"use client";

import { useState, useEffect, useRef } from "react";
const PHOTOS = [{
  url: "https://jokerstudio.ca/wp-content/uploads/2026/05/PHOTO-PORTRAIT-5-1-819x1024.png",
  cat: "Portrait",
  titre: "Portrait studio",
  ratio: "3/4"
}, {
  url: "https://jokerstudio.ca/wp-content/uploads/2026/05/PHOTO-PORTRAIT-4-595x1024.png",
  cat: "Portrait",
  titre: "Portrait professionnel",
  ratio: "9/16"
}, {
  url: "https://jokerstudio.ca/wp-content/uploads/2026/05/PHOTO-PORTRAIT-3-576x1024.png",
  cat: "Portrait",
  titre: "Portrait cinéma",
  ratio: "9/16"
}, {
  url: "https://jokerstudio.ca/wp-content/uploads/2026/05/PHOTO-PORTRAIT-2-1024x576.png",
  cat: "Portrait",
  titre: "Portrait naturel",
  ratio: "16/9"
}, {
  url: "https://jokerstudio.ca/wp-content/uploads/2026/05/PHOTO-MARIAGE-4-1-1024x576.png",
  cat: "Mariage",
  titre: "Cérémonie",
  ratio: "16/9"
}, {
  url: "https://jokerstudio.ca/wp-content/uploads/2026/05/PHOTO-MARIAGE-3-1024x576.png",
  cat: "Mariage",
  titre: "Moment complice",
  ratio: "16/9"
}, {
  url: "https://jokerstudio.ca/wp-content/uploads/2026/05/PHOTO-MARIAGE-1-1024x683.png",
  cat: "Mariage",
  titre: "Cérémonie intime",
  ratio: "3/2"
}, {
  url: "https://jokerstudio.ca/wp-content/uploads/2026/05/PHOTO-EVENEMENTS-2-1024x576.jpg",
  cat: "Événement",
  titre: "Soirée corporate",
  ratio: "16/9"
}, {
  url: "https://jokerstudio.ca/wp-content/uploads/2026/05/PHOTO-EVENEMENTS-1-1024x576.jpg",
  cat: "Événement",
  titre: "Couverture événement",
  ratio: "16/9"
}, {
  url: "https://jokerstudio.ca/wp-content/uploads/2026/05/PHOTO-FONDATEUR-1-1024x907.png",
  cat: "Corporatif",
  titre: "Fondateur",
  ratio: "4/3"
}, {
  url: "https://jokerstudio.ca/wp-content/uploads/2026/01/image_hq807nvc-1024x683.jpg",
  cat: "Corporatif",
  titre: "Ambiance de ville",
  ratio: "3/2"
}, {
  url: "https://img.youtube.com/vi/o-ScCw_UteY/hqdefault.jpg",
  yt: "o-ScCw_UteY",
  cat: "Vidéo",
  titre: "Reel cinématique",
  ratio: "16/9"
}, {
  url: "https://img.youtube.com/vi/6w4hIyrvRPE/hqdefault.jpg",
  yt: "6w4hIyrvRPE",
  cat: "Vidéo",
  titre: "Production vidéo",
  ratio: "16/9"
}, {
  url: "https://jokerstudio.ca/wp-content/uploads/2026/01/image_pmvyb9hs-1024x945.jpg",
  cat: "Portrait",
  titre: "Portrait groupe",
  ratio: "4/3"
}];
const CATS = ["Tous", "Portrait", "Mariage", "Événement", "Corporatif", "Vidéo"];
const MG_CSS = "@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@300;400;500&family=Cormorant+Garamond:ital,wght@1,400&display=swap');\n.mg-wrap{--bg:#0a0a0a;--sf:#111;--bd:rgba(255,255,255,.07);--wh:#f0ede8;--mu:rgba(240,237,232,.42);--go:#c8a96e;--ez:cubic-bezier(.22,1,.36,1);background:var(--bg);color:var(--wh);font-family:'DM Sans',sans-serif;font-weight:300;padding-bottom:80px}\n.mg-hero{position:relative;padding:100px 40px 64px;text-align:center;background:linear-gradient(to bottom,#0a0a0a 0%,#111 100%);border-bottom:1px solid var(--bd)}\n.mg-hero::before{content:'';position:absolute;inset:0;background-image:linear-gradient(rgba(255,255,255,.02) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.02) 1px,transparent 1px);background-size:60px 60px;pointer-events:none}\n.mg-stag{display:inline-flex;align-items:center;gap:10px;font-size:.63rem;letter-spacing:.25em;text-transform:uppercase;color:var(--go);margin-bottom:14px}\n.mg-stag::before,.mg-stag::after{content:'';display:block;width:24px;height:1px;background:var(--go)}\n.mg-htitle{font-family:'Bebas Neue',sans-serif;font-size:clamp(4rem,10vw,9rem);line-height:.85;letter-spacing:-.02em;margin-bottom:16px}\n.mg-htitle em{font-family:'Cormorant Garamond',serif;font-style:italic;color:var(--go);font-size:.85em}\n.mg-hsub{font-size:.9rem;color:var(--mu);max-width:460px;margin:0 auto}\n.mg-filters{display:flex;align-items:center;justify-content:center;gap:8px;flex-wrap:wrap;padding:40px 20px 32px}\n.mg-f{padding:8px 20px;font-size:.68rem;letter-spacing:.18em;text-transform:uppercase;background:transparent;color:var(--mu);border:1px solid var(--bd);cursor:pointer;transition:all .2s;font-family:'DM Sans',sans-serif}\n.mg-f:hover{color:var(--wh);border-color:rgba(255,255,255,.3)}\n.mg-f.act{background:var(--wh);color:#0a0a0a;border-color:var(--wh)}\n.mg-count{text-align:center;font-size:.68rem;letter-spacing:.18em;text-transform:uppercase;color:var(--mu);margin-bottom:32px}\n.mg-count span{color:var(--go);font-family:'Bebas Neue',sans-serif;font-size:1.1rem}\n.mg-grid{columns:3;column-gap:3px;padding:0 3px}\n.mg-item{break-inside:avoid;margin-bottom:3px;position:relative;overflow:hidden;cursor:pointer;display:block}\n.mg-item img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .7s var(--ez),filter .5s;filter:brightness(.84) saturate(.8)}\n.mg-item:hover img{transform:scale(1.07);filter:brightness(1) saturate(1.05)}\n.mg-ov{position:absolute;inset:0;background:linear-gradient(to top,rgba(0,0,0,.75),transparent 55%);opacity:0;transition:opacity .4s var(--ez);display:flex;align-items:flex-end;padding:18px}\n.mg-item:hover .mg-ov{opacity:1}\n.mg-info{transform:translateY(8px);transition:transform .4s var(--ez)}\n.mg-item:hover .mg-info{transform:translateY(0)}\n.mg-cat{font-size:.58rem;letter-spacing:.2em;text-transform:uppercase;color:var(--go);margin-bottom:2px}\n.mg-nom{font-family:'Bebas Neue',sans-serif;font-size:1.15rem;letter-spacing:.06em;color:#fff}\n.mg-zoom{position:absolute;top:14px;right:14px;width:32px;height:32px;background:rgba(0,0,0,.5);border:1px solid rgba(255,255,255,.2);border-radius:50%;display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .3s;backdrop-filter:blur(4px)}\n.mg-item:hover .mg-zoom{opacity:1}\n.mg-item{opacity:0;transform:translateY(24px);transition:opacity .6s var(--ez),transform .6s var(--ez)}\n.mg-item.vis{opacity:1;transform:translateY(0)}\n.mg-lb{position:fixed;inset:0;background:rgba(0,0,0,.95);z-index:9999;display:flex;align-items:center;justify-content:center;opacity:0;pointer-events:none;transition:opacity .35s;backdrop-filter:blur(8px)}\n.mg-lb.open{opacity:1;pointer-events:all}\n.mg-lbimg{max-width:90vw;max-height:88vh;object-fit:contain;transform:scale(.95);transition:transform .4s var(--ez)}\n.mg-lb.open .mg-lbimg{transform:scale(1)}\n.mg-lbx{position:absolute;top:24px;right:32px;font-size:.63rem;letter-spacing:.2em;text-transform:uppercase;color:rgba(240,237,232,.5);cursor:pointer;background:none;border:none;transition:color .2s}\n.mg-lbx:hover{color:#f0ede8}\n.mg-lbcap{position:absolute;bottom:28px;left:50%;transform:translateX(-50%);text-align:center}\n.mg-lbcap p:first-child{font-size:.6rem;letter-spacing:.2em;text-transform:uppercase;color:var(--go)}\n.mg-lbcap p:last-child{font-family:'Bebas Neue',sans-serif;font-size:1.4rem;color:#fff}\n@media(max-width:900px){.mg-grid{columns:2}}\n@media(max-width:600px){.mg-grid{columns:1}.mg-filters{gap:6px}.mg-htitle{font-size:clamp(3rem,12vw,5rem)}}.mg-item{position:relative;}.mg-play{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:62px;height:62px;border-radius:50%;background:rgba(0,0,0,.55);display:flex;align-items:center;justify-content:center;pointer-events:none;border:2px solid rgba(255,255,255,.85);transition:transform .25s ease,background .25s ease;z-index:2;}.mg-item:hover .mg-play{transform:translate(-50%,-50%) scale(1.08);background:rgba(0,0,0,.7);}.mg-lbvid{position:relative;width:min(90vw,1100px);aspect-ratio:16/9;background:#000;}.mg-lbvid iframe{position:absolute;inset:0;width:100%;height:100%;border:0;border-radius:4px;}";
export default function MediaGrid() {
  const [cat, setCat] = useState("Tous");
  const lbRef = useRef(null);
  const lbImgRef = useRef(null);
  const [lbData, setLbData] = useState({
    cat: "",
    titre: "",
    yt: ""
  });
  const filtered = cat === "Tous" ? PHOTOS : PHOTOS.filter(p => p.cat === cat);
  useEffect(() => {
    if (!document.getElementById("mg-style")) {
      const s = document.createElement("style");
      s.id = "mg-style";
      s.textContent = MG_CSS;
      document.head.appendChild(s);
    }
  }, []);
  useEffect(() => {
    const obs = new IntersectionObserver(entries => entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add("vis");
        obs.unobserve(e.target);
      }
    }), {
      threshold: 0.08,
      rootMargin: "0px 0px -30px 0px"
    });
    document.querySelectorAll(".mg-item").forEach((el, i) => {
      const el2 = el as HTMLElement;
      el2.style.transitionDelay = i % 3 * 0.07 + "s";
      obs.observe(el);
    });
    return () => obs.disconnect();
  }, [cat]);
  const openLB = (url: string, c: string, t: string, y: string = "") => {
    if (lbRef.current && lbImgRef.current) {
      (lbImgRef.current as HTMLImageElement).src = url;
      setLbData({
        cat: c,
        titre: t,
        yt: y
      });
      lbRef.current.classList.add("open");
      document.body.style.overflow = "hidden";
    }
  };
  const closeLB = () => {
    lbRef.current && lbRef.current.classList.remove("open");
    setLbData({
      cat: "",
      titre: "",
      yt: ""
    });
    document.body.style.overflow = "";
  };
  return <div className="mg-wrap">
      {/* Hero galerie */}
      <div className="mg-hero">
        <p className="mg-stag">JokerStudio</p>
        <h1 className="mg-htitle">Notre <em>galerie</em></h1>
        <p className="mg-hsub">Vidéographie, photographie et couverture d’événements professionnels à Montréal</p>
      </div>

      {/* Filtres par catégorie */}
      <div className="mg-filters">
        {CATS.map(c => <button key={c} className={"mg-f" + (cat === c ? " act" : "")} onClick={() => setCat(c)}>{c}</button>)}
      </div>

      {/* Compteur */}
      <p className="mg-count"><span>{filtered.length}</span> photo{filtered.length > 1 ? "s" : ""}</p>

      {/* Grille masonry */}
      <div className="mg-grid">
        {filtered.map((p, i) => <div key={p.url} className="mg-item" style={{
        aspectRatio: p.ratio
      }} onClick={() => openLB(p.url, p.cat, p.titre, (p as any).yt)} onKeyDown={e => e.key === "Enter" && openLB(p.url, p.cat, p.titre, (p as any).yt)} role="button" tabIndex={0}>
            <img src={p.url} alt={p.titre} loading="lazy" />
            {(p as any).yt && <div className="mg-play" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="white"><path d="M8 5v14l11-7z" /></svg>
              </div>}
            <div className="mg-ov">
              <div className="mg-info">
                <p className="mg-cat">{p.cat}</p>
                <p className="mg-nom">{p.titre}</p>
              </div>
            </div>
            <div className="mg-zoom" aria-hidden="true">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M9 1h4v4M5 9l8-8M1 9h4v4" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          </div>)}
      </div>

      {/* Lightbox */}
      <div className="mg-lb" ref={lbRef} onClick={e => {
      if (e.target === lbRef.current) closeLB();
    }} role="dialog" aria-modal="true">
        <button className="mg-lbx" onClick={closeLB} aria-label="Fermer">Fermer ✕</button>
        <img ref={lbImgRef} src="" alt="" className="mg-lbimg" style={{
        display: lbData.yt ? "none" : "block"
      }} />
        {lbData.yt && <div className="mg-lbvid">
            <iframe src={`https://www.youtube.com/embed/${lbData.yt}?autoplay=1&rel=0`} title={lbData.titre} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
          </div>}
        <div className="mg-lbcap">
          <p>{lbData.cat}</p>
          <p>{lbData.titre}</p>
        </div>
      </div>
    </div>;
}